import { useForm } from 'react-hook-form'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { Button, Dropdown } from 'components/common'
import SearchBar from 'components/common/dataTable/searchBar'
import { PlusIcon } from 'components/icons'
import {
  FreshCategoryTable,
  statusFilterOptions,
} from 'components/freshCategory'
import { usePageAccess, useQuery } from 'hooks'
import { PAGE_FRESH_CATEGORY_ADD } from 'utils/constants'

const FreshCategoryList = () => {
  const navigate = useNavigate()
  const { isEditor } = usePageAccess()
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const { setValue } = useForm()

  // useQuery JSON-parses values, so 'true' comes back as a boolean
  const isActive = getQuery('isActive')

  const handleStatusChange = (value: unknown) => {
    if (value === 'true' || value === 'false') {
      setMultipleQueries({ isActive: value, page: 1 })
    } else {
      removeQuery('isActive')
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Fresh Category Management</title>
      </Helmet>

      {isEditor && (
        <Button
          buttonText="Create New Category"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_FRESH_CATEGORY_ADD.path)}
        />
      )}

      <div
        className={`${
          isEditor ? 'mt-4' : ''
        } mb-2 flex flex-wrap items-center justify-between gap-3 md:mb-0 md:flex-nowrap`}
      >
        <h3 className="title">Fresh Categories</h3>

        <div className="flex w-full items-center justify-end gap-3">
          <div className="w-full max-w-36">
            <Dropdown
              name="isActive"
              size="small"
              setValue={setValue}
              options={statusFilterOptions}
              defaultValue={isActive === null ? 'NONE' : String(isActive)}
              onChange={handleStatusChange}
            />
          </div>
          <SearchBar placeholder="Search by Category Name" />
        </div>
      </div>

      <FreshCategoryTable isEditor={isEditor} />
    </>
  )
}

export default FreshCategoryList
